import VipUseRecordApp from './VipUseRecordApp';
import MedicalUseRecordApp from './MedicalUseRecordApp';
import GroupUseRecordApp from './GroupUseRecordApp';
import CompanyUseRecordApp from './CompanyUseRecordApp';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const UseRecordAppConfig = {
    settings: {
        layout: {
            config: {
                footer : {
                    display: false
                }
            }
        }
    },
    auth: authRoles.admin, //  ['cc']
    routes: [
        {
            path: '/cc/vip/:vipId/useRecord',
            component: VipUseRecordApp
        },
        {
            path: '/cc/medical/:medicalId/useRecord',
            component: MedicalUseRecordApp
        },
        {
            path: '/cc/group/:groupId/useRecord',
            component: GroupUseRecordApp
        },
        {
            path: '/cc/company/:companyId/useRecord',
            component: CompanyUseRecordApp
        },
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/useRecord/UseRecordAppConfig.js